import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCatalog from './catalog.reducer';

export const reducers = fromCatalog.reducer;

export const selectCatalogState = createFeatureSelector('catalogPage');

export const getState = createSelector(selectCatalogState, fromCatalog.getState);
